import script from "./PointsOverviewModalNew.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsOverviewModalNew.vue?vue&type=script&setup=true&lang=js"

import "./PointsOverviewModalNew.vue?vue&type=style&index=0&id=d360f8f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d360f8f2"]])

export default __exports__